import React from 'react';
import PropTypes from 'prop-types';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';

const ObjectivesTimelineChart = ({ data }) => {
  // Group objectives by completion month
  const monthCounts = {};
  const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

  data.forEach(obj => {
    if (obj.suggested_completion_date) {
      try {
        const date = new Date(obj.suggested_completion_date);
        const month = monthNames[date.getMonth()];
        const year = date.getFullYear();
        const key = `${month} ${year}`;
        monthCounts[key] = (monthCounts[key] || 0) + 1;
      } catch (e) {
        console.error('Invalid date:', obj.suggested_completion_date);
      }
    }
  });

  // Sort by date
  const chartData = Object.keys(monthCounts)
    .map(key => ({
      month: key,
      count: monthCounts[key]
    }))
    .sort((a, b) => {
      const dateA = new Date(a.month);
      const dateB = new Date(b.month);
      return dateA - dateB;
    });

  const hasData = chartData.length > 0;

  const renderCustomTooltip = ({ active, payload }) => {
    if (active && payload && payload.length) {
      const data = payload[0];
      return (
        <div style={{
          backgroundColor: '#fff',
          border: '1px solid #ddd',
          borderRadius: '4px',
          padding: '10px',
          boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
        }}>
          <p style={{ margin: 0, fontWeight: 'bold', color: '#000' }}>
            {`${data.payload.month}: ${data.value} objective${data.value !== 1 ? 's' : ''} due`}
          </p>
        </div>
      );
    }
    return null;
  };

  return (
    <ResponsiveContainer height={300} width="100%">
      {hasData ? (
        <BarChart data={chartData} margin={{ top: 20, right: 30, left: 20, bottom: 60 }}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis 
            dataKey="month" 
            angle={-45}
            textAnchor="end"
            height={80}
          />
          <YAxis />
          <Tooltip content={renderCustomTooltip} />
          <Legend />
          <Bar dataKey="count" name="Objectives Due" fill="#00C49F" radius={[8, 8, 0, 0]} />
        </BarChart>
      ) : (
        <div style={{
          height: 300,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: 18,
          color: '#888'
        }}>
          No Data Available
        </div>
      )}
    </ResponsiveContainer>
  );
};

ObjectivesTimelineChart.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape({
    suggested_completion_date: PropTypes.string,
  })).isRequired,
};

export default ObjectivesTimelineChart;

